<app-page
  [flush]="true"
  pageTitle="Kalendar"
  pageDescription="Pregled zauzetih i dostupnih termina"
>
  <div headerActions class="legend flex align-items-center">
    <div class="flex align-items-center gap-2">
      <span class="legend-dot mine"></span>
      <span class="text-sm-medium text-gray-600">Moj termin</span>
    </div>
    <div class="flex align-items-center gap-2">
      <span class="legend-dot unavailable"></span>
      <span class="text-sm-medium text-gray-600">Nedostupno</span>
    </div>
  </div>

  <div class="cal-card flex flex-column mt-5">
    <div class="cal-toolbar flex align-items-center justify-content-between">
      <div class="flex align-items-center gap-3">
        <div class="date-badge flex flex-column align-items-center justify-content-center">
          <div class="text-xs-semibold text-gray-700">{{ badgeMonth() }}</div>
          <div class="display-xs-semibold text-gray-900">{{ badgeDay() }}</div>
        </div>
        <div class="flex flex-column cal-title">
          <div class="text-lg-semibold text-gray-900">{{ titleLabel() }}</div>
          <div class="text-sm-regular text-gray-600">{{ rangeLabel() }}</div>
        </div>
      </div>
      <div class="nav-group flex align-items-stretch">
        <button type="button" class="nav-group__btn nav-group__btn--icon" (click)="prev()" aria-label="Prethodna nedelja">
          <app-arrow direction="left" stroke="#414651" width="14px" height="14px"></app-arrow>
        </button>
        <button type="button" class="nav-group__btn text-sm-semibold text-gray-700" (click)="today()">Danas</button>
        <button type="button" class="nav-group__btn nav-group__btn--icon" (click)="next()" aria-label="Sledeća nedelja">
          <app-arrow direction="right" stroke="#414651" width="14px" height="14px"></app-arrow>
        </button>
      </div>
    </div>

    <div class="cal-body flex">
      <div class="cal-grid flex-1">
        @if (showCalendar()) {
        <full-calendar #fc [options]="calendarOptions">
          <ng-template #eventContent let-arg>
            @if (arg.event.extendedProps.isMine) {
              <div class="fc-event-card flex flex-column gap-1">
                <div class="text-xs-semibold event-title">{{ formatEventDate(arg.event.start) }}</div>
                <div class="flex align-items-center gap-1 event-time">
                  <app-clock [stroke]="arg.event.textColor || '#414651'" width="0.75rem" height="0.75rem"></app-clock>
                  <span class="text-xs-regular event-time__text">{{ formatTime(arg.event.start) }} - {{ formatTime(arg.event.end) }}</span>
                </div>
              </div>
            } @else {
              <div class="fc-event-card unavailable flex flex-column gap-1">
                <div class="text-xs-semibold event-title">Nedostupno</div>
                <div class="flex align-items-center gap-1 event-time">
                  <app-clock [stroke]="arg.event.textColor || '#414651'" width="0.75rem" height="0.75rem"></app-clock>
                  <span class="text-xs-regular event-time__text">{{ formatTime(arg.event.start) }} - {{ formatTime(arg.event.end) }}</span>
                </div>
              </div>
            }
          </ng-template>
        </full-calendar>
        }
      </div>
    </div>
  </div>
</app-page>

<app-client-appointment-details-drawer
  [(visible)]="showDrawer"
  [appointmentId]="drawerAppointmentId()"
  (cancelled)="onDrawerAction()"
  (rescheduled)="onDrawerAction()"
  (documentUploaded)="onDrawerAction()"
></app-client-appointment-details-drawer>
